var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWww = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.516 0c-4.687 0-8.5 3.813-8.5 8.5s3.813 8.5 8.5 8.5 8.5-3.813 8.5-8.5S13.202 0 8.516 0M1.041 9h2.937c.044 1.024.211 2.031.513 3H1.888a7.4 7.4 0 0 1-.847-3m2.937-1H1.041a7.4 7.4 0 0 1 .847-3h2.6a11.8 11.8 0 0 0-.51 3m1.569-3h5.896c.33.965.522 1.972.569 3H4.978c.046-1.028.239-2.035.569-3m-.569 4h7.035a10.8 10.8 0 0 1-.572 3H5.55a10.8 10.8 0 0 1-.572-3m8.035 0h2.978a7.4 7.4 0 0 1-.847 3H12.5c.302-.969.469-1.976.513-3m0-1a11.8 11.8 0 0 0-.51-3h2.641c.48.906.775 1.923.847 3zm1.489-4h-2.354a12.2 12.2 0 0 0-1.55-2.7A7.52 7.52 0 0 1 14.502 4M9.074 1.028c.824.897 1.484 1.9 1.972 2.972H5.944a11.3 11.3 0 0 1 1.97-2.97c.199-.015.398-.03.602-.03.188 0 .373.015.558.028m-2.691.285A12.2 12.2 0 0 0 4.843 4H2.529a7.5 7.5 0 0 1 3.854-2.687M2.529 13h2.317c.391.951.915 1.851 1.547 2.689A7.5 7.5 0 0 1 2.529 13m5.397 2.97A11.4 11.4 0 0 1 5.948 13h5.094a11.3 11.3 0 0 1-1.979 2.972c-.181.013-.363.028-.547.028-.2 0-.395-.015-.59-.03m2.661-.267A12.2 12.2 0 0 0 12.144 13h2.358a7.5 7.5 0 0 1-3.915 2.703"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWww);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/www.svg";